import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { get, map } from "lodash";
import { withTranslation } from "react-i18next";

//i18n
import i18n from "../../../i18n";
import languages from "common/languages";

const LanguageDropdown = () => {
  const [selectedLang, setSelectedLang] = useState("eng");
  const [menu, setMenu] = useState(false);

  useEffect(() => {
    let currentLanguage = localStorage.getItem("I18N_LANGUAGE");
    if (currentLanguage) {
      if(currentLanguage === "en") {
        currentLanguage = "eng";
      }
      setSelectedLang(currentLanguage);
      i18n.changeLanguage(currentLanguage);
    } else {
      setSelectedLang("eng");
      i18n.changeLanguage("eng");
      localStorage.setItem("I18N_LANGUAGE", "eng");
    }
  }, []);

  const changeLanguageAction = lang => {
    setSelectedLang(lang);
    i18n.changeLanguage(lang);
    localStorage.setItem("I18N_LANGUAGE", lang);
    window.location.reload();
  }

  const toggle = () => {
    setMenu(!menu);
  }

  return (
    <>
      <Dropdown isOpen={menu} toggle={toggle} className="d-inline-block">
        <DropdownToggle className="btn header-item" tag="button">
          <img
            src={get(languages, `${selectedLang}.flag`)}
            alt={get(languages, `${selectedLang}.label`)}
            height="16"
            className="me-1"
          />
          <span>{get(languages, `${selectedLang}.label`)}</span>
        </DropdownToggle>
        <DropdownMenu className="language-switch dropdown-menu-end">
          {map(Object.keys(languages), key => (
            <DropdownItem
              key={key}
              onClick={() => changeLanguageAction(key)}
              className={`notify-item ${selectedLang === key ? "active" : "none"
                }`}
            >
              <img
                src={get(languages, `${key}.flag`)}
                alt="website"
                className="me-1"
                height="12"
              />
              <span className="align-middle">
                {get(languages, `${key}.label`)}
              </span>
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    </>
  )
}

export default withTranslation()(LanguageDropdown)
